import type { TFunction } from 'i18next'

export const getPricingTypeChoices = (t: TFunction) => [
	{
		value: 'rule_based_repricing',
		label: t('RB', { defaultValue: 'RB' }),
		variant: 'warning',
	},
	{
		value: 'demand_based_repricing',
		label: t('ML', { defaultValue: 'ML' }),
		variant: 'info',
	},
	{
		value: 'markdown_repricing',
		label: t('MD', { defaultValue: 'MD' }),
		variant: 'epic',
	},
	{
		value: 'promo_repricing',
		label: t('Promo', { defaultValue: 'Promo' }),
		variant: 'success',
	},
	{
		value: 'manual_repricing',
		label: t('pricing_type_manual_repricing', {
			defaultValue: 'pricing_type_manual_repricing',
		}),
		variant: 'default',
	},
	{
		value: 'none',
		label: t('none', { defaultValue: 'none' }),
		variant: 'neutral',
	},
]
